<template>
  <returnButton />
  <div class="main-container">
    <div class="title-header" style="margin: 20px 0">
      <h1 class="title">Información del Doctor</h1>
    </div>
    <div class="content-container">
      <v-form ref="form" v-model="valid">
        <v-row class="mr-5 ml-4 mt-4" no-gutters>
          <v-col cols="12" md="6" class="pl-3 mb-3 pr-3">
            <v-text-field
              v-model="form.name"
              label="Nombre"
              variant="outlined"
              required
            >
              <template #prepend>
                <v-icon>mdi mdi-account-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pl-3 mb-3 pr-3">
            <v-text-field
              v-model="form.lastname[0]"
              label="Apellido paterno"
              variant="outlined"
              required
            >
              <template #prepend>
                <v-icon>mdi mdi-account-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pl-3 mb-3 pr-3">
            <v-text-field
              v-model="form.lastname[1]"
              label="Apellido materno"
              variant="outlined"
            >
              <template #prepend>
                <v-icon>mdi mdi-account-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pl-3 mb-3 pr-3">
            <v-select
              v-model="form.gender"
              :items="genderOptions"
              item-title="text"
              item-value="value"
              label="Género"
              variant="outlined"
              required
            >
              <template #prepend>
                <v-icon>mdi mdi-gender-male-female</v-icon>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row class="mr-5 ml-4 mt-4" no-gutters>
          <h2 class="titulos">Información consultorio</h2>
          <v-col cols="12" md="12" class="pl-3 mb-3 pr-3">
            <v-select
              v-model="form.prefix"
              label="Indicar Dr/Dra"
              :items="['Dr.', 'Dra.']"
              variant="outlined"
            >
              <template #prepend>
                <v-icon>mdi mdi-clipboard-pulse-outline</v-icon>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row class="mr-5 ml-4 mt-4" no-gutters>
          <v-col
            v-for="(contact, index) in contacts"
            :key="index"
            cols="12"
            md="6"
            class="pl-3 mb-3 pr-3"
          >
            <v-text-field
              v-model="contact.value"
              variant="outlined"
              :label="contact.display"
              :rules="getRules(contact.system)"
            >
              <template #prepend>
                <v-icon>{{
                  contact.system === "email" ? "mdi-email" : "mdi-phone"
                }}</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="12" class="pl-3 mt-5 mb-3 pr-3">
            <v-text-field
              v-model="form.aditional_data_one"
              label="Informacion Adicional1"
              variant="outlined"
              placeholder="Puedes colocar tus horarios u otra información adicional que consideres necesario."
            >
              <template #prepend>
                <v-icon>mdi mdi-text-box</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="12" class="pl-3 mb-3 pr-3">
            <v-text-field
              v-model="form.aditional_data_two"
              label="Informacion Adcional2"
              variant="outlined"
              placeholder="Alguna informacion que consideres necesario sea de utilidad para el paciente."
            >
              <template #prepend>
                <v-icon>mdi mdi-text-box</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <h2 class="titulos">Certificaciones</h2>
        <v-row
          v-for="(qual, index) in form.qualifications"
          :key="index"
          class="mr-4 ml-4 mt-4"
          no-gutters
        >
          <!-- Primera columna -->
          <v-col :cols="12" :md="index > 0 ? 5 : 6" class="pl-3 mb-3 pr-3">
            <v-row no-gutters>
              <v-col cols="12" class="mb-3">
                <v-text-field
                  v-model="qual.identifier"
                  label="Cédula Profesional"
                  variant="outlined"
                  required
                >
                  <template #prepend>
                    <v-icon>mdi mdi-identifier</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-select
                  v-model="qual.type"
                  :items="qualificationTypes"
                  label="Tipo de Certificación"
                  variant="outlined"
                  required
                >
                  <template #prepend>
                    <v-icon>mdi mdi-format-list-checks</v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>

          <!-- Segunda columna -->
          <v-col :cols="12" :md="index > 0 ? 6 : 6" class="pl-3 mb-3 pr-3">
            <v-row no-gutters>
              <v-col cols="12" class="mb-3">
                <v-text-field
                  v-model="qual.professionalLicense"
                  label="Titulo"
                  variant="outlined"
                  required
                >
                  <template #prepend>
                    <v-icon>mdi mdi-certificate-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="qual.issuer.reference"
                  label="Institución Emisora"
                  variant="outlined"
                  required
                >
                  <template #prepend>
                    <v-icon>mdi mdi-school-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            v-if="index > 0"
            cols="12"
            md="1"
            class="d-flex flex-column align-center justify-center pr-3 mb-8"
          >
            <v-btn
              color="error"
              icon
              @click="removeQualification(index)"
              class="mt-auto mb-auto"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="mr-5 ml-4 mt-4" no-gutters>
          <v-col cols="12" class="pl-3 mb-3 pr-3">
            <button class="boton-principal pr-2" @click="addQualification">
              <v-icon icon="mdi-plus" color="white" class="icon"></v-icon>
              Agregar Certificación
            </button>
          </v-col>
        </v-row>
        <div v-if="!practitionerId">
          <h2>Informacion de inicio de sesion</h2>
          <v-row class="mr-5 ml-4 mt-4" no-gutters>
            <v-col cols="12" md="6" class="pl-3 mb-3 pr-3">
              <v-text-field
                v-model="form.user"
                label="Usuario"
                variant="outlined"
                required
              >
                <template #prepend>
                  <v-icon>mdi mdi-account-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pl-3 mb-3 pr-3">
              <v-text-field
                v-model="form.password"
                label="Contraseña"
                variant="outlined"
                type="password"
                required
              >
                <template #prepend>
                  <v-icon>mdi mdi-account-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-row no-gutters>
          <v-col cols="12" class="pl-3 mb-3 pr-3 d-flex justify-end">
            <button class="boton-principal pr-2" @click="submitForm">
              Enviar
            </button>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import {
  getPractitioner,
  putPractitioner,
  postPractitioner,
} from "@/api/practicante";
import returnButton from "@/components/global/return-button.vue";

export default {
  components: {
    returnButton,
  },
  data() {
    return {
      form: {
        identifier: "",
        name: "",
        lastname: ["", ""],
        phone: "",
        email: "",
        gender: "Female",
        qualifications: [
          {
            identifier: "",
            professionalLicense: "",
            type: "Profesional",
            issuer: {
              reference: "",
            },
          },
        ],
        prefix: "Dra.",
        internal_practitioner: true,
        location: "",
        postal_code: "",
        aditional_data_one: "",
        aditional_data_two: "",
        user: "",
        password: "",
      },
      genderOptions: [
        { text: "Femenino", value: "female" },
        { text: "Masculino", value: "male" },
        { text: "Otro", value: "other" },
      ],
      qualificationTypes: ["Estatal", "Federal", "Profesional"],
      contacts: [
        { system: "phone", display: "Telefono", value: "" },
        { system: "email", display: "Correo electronico", value: "" },
      ],
      locations: [],
      valid: false,
      practitionerId: "",
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.practitionerId = this.$route.params.id;
      this.fetchPractitioner();
    }
  },
  methods: {
    fetchPractitioner() {
      getPractitioner(this.practitionerId)
        .then((data) => {
          this.form = {
            ...this.form,
            ...data,
            lastname: data.lastname || ["", ""],
            qualifications: data.qualification.length
              ? data.qualification
              : this.form.qualifications,
          };
          this.contacts = this.contacts.map((contact) => {
            if (contact.system === "phone") {
              return {
                ...contact,
                value: data.telecom?.[0]?.phone || "",
              };
            } else if (contact.system === "email") {
              return {
                ...contact,
                value: data.telecom?.[0]?.email || "",
              };
            }
            return contact;
          });
        })
        .catch((error) => console.error(error));
    },
    getRules(system) {
      if (system === "email") {
        return [
          /**
           * Valida que el valor sea un correo electrónico válido.
           * Permite valores vacíos (campo opcional).
           * La regex verifica que el valor tenga un formato de correo electrónico básico.
           * @param {string} v - El valor a validar.
           * @returns {boolean|string} - True si es válido, o un mensaje de error si no lo es.
           */
          (v) => !v || /.+@.+\..+/.test(v) || "Correo electrónico inválido",
        ];
      }
      return [
        /**
         * Valida que el valor sea un número de teléfono válido.
         * Permite valores vacíos (campo opcional).
         * La regex verifica que el valor contenga solo dígitos y tenga una longitud de 10 caracteres.
         * @param {string} v - El valor a validar.
         * @returns {boolean|string} - True si es válido, o un mensaje de error si no lo es.
         */
        (v) => /^\d{10}$/.test(v) || "Número de teléfono inválido",
      ];
    },
    addQualification() {
      this.form.qualifications.push({
        identifier: "",
        professionalLicense: "",
        type: "Estatal",
        issuer: {
          reference: "",
        },
      });
    },
    removeQualification(index) {
      if (this.form.qualifications.length > 1) {
        this.form.qualifications.splice(index, 1);
      }
    },
    validateForm() {
      if (this.form.qualifications.length === 0) {
        this.showError("Debe agregar al menos una certificación");
        return false;
      }

      const hasValidQualification = this.form.qualifications.some(
        (qual) =>
          qual.identifier &&
          qual.professionalLicense &&
          qual.type &&
          qual.issuer.reference
      );

      if (!hasValidQualification) {
        this.showError(
          "Complete todos los campos de al menos una certificación"
        );
        return false;
      }

      return true;
    },
    submitForm() {
      if (!this.validateForm()) {
        return;
      }

      const practitionerData = {
        username: this.form.user,
        password: this.form.password,
        active: true,
        name: [this.form.name],
        lastname: this.form.lastname,
        telecom: [
          {
            phone:
              this.contacts.find((c) => c.system === "phone")?.value || null,
            email:
              this.contacts.find((c) => c.system === "email")?.value || null,
          },
        ],
        gender: this.form.gender,
        qualification: this.form.qualifications,
        prefix: this.form.prefix,
        internal_practitioner: true,
        location: this.form.location || null,
        postal_code: this.form.postal_code || null,
        aditional_data: [],
      };

      if (this.form.aditional_data_one) {
        practitionerData.aditional_data.push(this.form.aditional_data_one);
      }
      if (this.form.aditional_data_two) {
        practitionerData.aditional_data.push(this.form.aditional_data_two);
      }
      if (!this.practitionerId) {
        // Crear nuevo practicante
        postPractitioner(practitionerData)
          .then(() => {
            this.$router.push({ name: "VerPracticantes" });
          })
          .catch((error) => this.showError(error.message));
        return;
      }
      putPractitioner(practitionerData, this.$route.params.id).catch((error) =>
        this.showError(error.message)
      );
    },

    showError(error) {
      console.log(error);
    },
  },
};
</script>
<style>
.titulos {
  margin-bottom: 10px;
}
</style>
